import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Paper, Typography, IconButton } from '@material-ui/core/';
import MenuIcon from '@material-ui/icons/Menu';

import FlowGraph from './FlowGraph';
import GraphOverLayEvaluation from './GraphOverLayEvaluation';
import GraphOverLay from './GraphOverLay';

import {
	switchGraphDataEigenverbrauch,
	switchGraphDataNetzentgelte,
} from './data/flowGraphData';

const Root = styled(Paper)`
	position: relative;
	overflow: hidden;
	margin-top: 40px;
	padding: 20px;
	border-radius: 5px;

	.graph-head {
		display: flex;
		align-items: center;
		justify-content: space-between;

		h5 {
			font-size: 16px;
			line-height: 48px;
			font-weight: bold;
			text-transform: uppercase;
		}

		button {
			color: ${(props) => props.theme.palette.text.primary};
		}
	}

	.graph-content {
		position: relative;
	}
`;

const GraphContainer = ({ data, activeCase, isStoragePark, streamGraphData }) => {
	const [openPanelRight, showPanelRight] = useState(true);
	const [openPanelLeft, showPanelLeft] = useState(false);
	const [hidegraphData, showGraphData] = useState({});
	const [openSwitchContent, showSwitchContent] = useState('Storage Park');
	const [activeCaseSwitchData, setActiveCaseSwitchData] = useState(
		switchGraphDataNetzentgelte
	);
	const [activeSelectionRightPannel, setActiveSelectionRightPannel] = useState(null);

	useEffect(() => {
		// eslint-disable-next-line
		activeCase
			? setActiveCaseSwitchData(switchGraphDataNetzentgelte)
			: setActiveCaseSwitchData(switchGraphDataEigenverbrauch);

		if (isStoragePark) {
			const newData = [...activeCaseSwitchData];
			const index = activeCaseSwitchData.findIndex(
				(o) => o.name === 'scalebloc' // ? 'storage.cab' : 'storage.park'
			);

			if (index > -1) {
				newData[index].name = 'scalecube';
			}

			setActiveCaseSwitchData(newData);
		}
	}, [activeCase, isStoragePark]);

	const openLeftPanel = (valueLink = '') => {
		showPanelLeft(true);
		showSwitchContent(valueLink);
	};

	const closeLeftPanel = () => {
		showPanelLeft(false);
		setActiveSelectionRightPannel(null);
	};

	const toggleRightPanel = () => {
		showPanelRight((prev) => !prev);
	};

	const toggelGraphData = (dataKey) => {
		showGraphData({
			...hidegraphData,
			[dataKey]: !hidegraphData[dataKey],
		});
	};

	const combindedToggle = () => {
		toggleRightPanel();
		if (!openPanelLeft) showPanelLeft(false);
	};

	return (
		<Root>
			<div className="graph-head">
				<Typography variant="h5">Simulation der Optimierung</Typography>
				{!openPanelRight && (
					<IconButton onClick={toggleRightPanel}>
						<MenuIcon />
					</IconButton>
				)}
			</div>

			<div className="graph-content">
				<GraphOverLayEvaluation
					toggle={closeLeftPanel}
					SlideIn={openPanelLeft}
					valueLink={openSwitchContent}
					activeCase={activeCase}
					data={data}
				/>

				<GraphOverLay
					toggle={toggleRightPanel}
					SlideIn={openPanelRight}
					switchData={activeCaseSwitchData}
					toggleClose={combindedToggle}
					toggleLeftPanel={openLeftPanel}
					toggleGraphData={toggelGraphData}
					toggleActiveSelection={(id) => {
						setActiveSelectionRightPannel(id);
					}}
					activeSelected={activeSelectionRightPannel}
				/>

				<FlowGraph
					data={streamGraphData}
					activeCase={activeCase}
					activeCaseData={activeCaseSwitchData}
					boolHidden={hidegraphData}
					streamGraphUnit={data.stream_graph_unit}
				/>
			</div>
		</Root>
	);
};

export default GraphContainer;
